// Shared formatting helpers for the portal

export const WASTE_LABELS = {
  sanitary: "Sanitary",
  male_sanitary: "Male Sanitary",
  sharps: "Sharps",
  clinical: "Clinical",
  offensive: "Offensive",
  pharmaceutical: "Pharmaceutical",
  nappy: "Nappy",
  washroom: "Washroom",
  sharps_orange: "Sharps (Orange)",
  sharps_infectious: "Sharps (Infectious)",
  sharps_medicinal: "Sharps (Medicinal)",
  sharps_cytotoxic: "Sharps (Cytotoxic)",
  sharps_pharmaceutical: "Sharps (Pharmaceutical)",
};

export const wasteLabel = (t) => WASTE_LABELS[t] || (t ? t.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "");

export const REQUEST_KINDS = [
  { value: "extra_collection", label: "Extra collection" },
  { value: "add_container", label: "Add a container" },
  { value: "remove_container", label: "Remove a container" },
  { value: "upgrade_container", label: "Upgrade a container" },
  { value: "downgrade_container", label: "Downgrade a container" },
  { value: "change_frequency", label: "Change collection frequency" },
  { value: "update_contact", label: "Update contact details" },
  { value: "general_support", label: "General support" },
];

export const WASTE_OPTIONS = [
  "sanitary",
  "male_sanitary",
  "offensive",
  "nappy",
  "sharps",
  "clinical",
  "pharmaceutical",
];

export function formatDate(value, opts) {
  if (!value) return "\u2014";
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    return d.toLocaleDateString("en-GB", opts || { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return String(value);
  }
}

export function formatDateTime(value) {
  if (!value) return "\u2014";
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    return d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return String(value);
  }
}

export function formatMoney(value, currency = "GBP") {
  if (value === null || value === undefined || isNaN(Number(value))) return "\u2014";
  try {
    return new Intl.NumberFormat("en-GB", { style: "currency", currency }).format(Number(value));
  } catch {
    return `\u00a3${Number(value).toFixed(2)}`;
  }
}

export function titleCase(s) {
  if (!s) return "";
  return String(s).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
